export enum Step {
  Start,
  RoundOne,
  RoundOneGuessing,
  RoundOneFail,
  RoundTwo,
  RoundTwoGuessing,
  RoundTwoFail,
  RoundThree,
  RoundThreeGuessing,
  RoundThreeFail,
  Success,
}
